/**
 * @generated SignedSource<<c29b89a400ca6a5c8c0d977dc3ad322b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useRelationshipTypeCriteria_query$data = {
  readonly currentUser: {
    readonly relationshipTypeCriteria: {
      readonly nodes: ReadonlyArray<{
        readonly relationshipTypeId: any;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly " $fragmentType": "useRelationshipTypeCriteria_query";
};
export type useRelationshipTypeCriteria_query$key = {
  readonly " $data"?: useRelationshipTypeCriteria_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRelationshipTypeCriteria_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useRelationshipTypeCriteria_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                "RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC"
              ]
            }
          ],
          "concreteType": "RelationshipTypeCriterionConnection",
          "kind": "LinkedField",
          "name": "relationshipTypeCriteria",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RelationshipTypeCriterion",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "relationshipTypeId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "relationshipTypeCriteria(orderBy:[\"RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "e7a5b184a02b7254b0b9fbf7812fe489";

export default node;
